export default `
varying float vColourState;
varying float vDist;
varying float vCircleAlpha;

void main() {
    if (vColourState <= 1.0) {
        // between white and lavendar
        gl_FragColor.rgba = mix(
            vec4(1.0, 1.0, 1.0, vCircleAlpha),
            // vec4(0.698, 0.616, 0.796, vCircleAlpha * vDist),
            vec4(0.698, 0.616, 0.796, vCircleAlpha * vDist),
            vColourState
        );
    } else if (vColourState <= 2.0) {
        // Between lavendar and purple
        gl_FragColor.rgba = mix(
            vec4(0.698, 0.616, 0.796, vCircleAlpha * vDist),
            vec4(0.522, 0.439, 0.651,  vCircleAlpha * vDist),
            vColourState - 1.0
        );
    }
   
}

`;
